import {
    http
} from '@/utils/http'
//查询prompt
export function getPrompt(data) {
    return http.get('/api/cmcc/migu_sf/templates/prompt', data)
}
//提交文生图任务
export function generateImgTask(data) {
    return http.post('/api/cmcc/migu_sf/image/txt2img/sync', data)
}
//提交图生视频任务
export function generateTask(data) {
    return http.post('/api/cmcc/migu_sf/video/img2video/sync', data)
}
//获取文生视频历史记录
export function getHistory(data) {
    return http.get('/api/cmcc/migu_sf/history/img2video', data)
}
//获取创作示例
export function getWorks(data) {
    return http.get('/api/cmcc/migu_sf/works', data)
}
//删除历史记录
export function delHistory(data) {
    return http.delete(`/api/cmcc/migu_sf/history/img2video/${data}`)
}
//获取剩余次数
export function getRemainCount(data) {
    return http.get('/api/cmcc/migu_sf/remainCount', data)
}
export function getSetting() {
    return http.get(`/api/cmcc/migu_sf/banner`)
}
export function getPetsList(data) {
    return http.get(`/api/cmcc/migu_sf/templates/media`,data)
}